import { Navigate } from 'react-router-dom'
import { useAuth } from '@/contexts/auth-context'
import { Loader2 } from 'lucide-react'

// Settings is no longer a dedicated page — it opens as a modal via the
// `#settings` URL hash. Anyone hitting `/settings` directly gets routed:
// authed users to /library with the settings modal opened, anon to /login.
export default function SettingsRedirect() {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    )
  }

  const isAnon = !user || !!user.isAnonymous
  if (isAnon) return <Navigate to="/#signin" replace />

  return <Navigate to="/library#settings" replace />
}
